import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const circularLoaderComponent = {
  root: 'circular-loader.root',
} as const satisfies ComponentLocatorMap;
